import * as _ from 'lodash';
import * as Types from './types';

// We treat these specially, for example by automatically
// joining using them.
// TODO: it would be much better to handle this with the type system!
export const SPECIAL_ID_COLUMN_NAMES = ['id', 'uuid'];

export function isIdColumnName(colName: string) {
  return SPECIAL_ID_COLUMN_NAMES.includes(colName.toLowerCase());
}

export interface WBType {
  wb_type: string;
  params?: {[key: string]: any};
}

export interface DictionaryWBType extends WBType {
  wb_type: 'dictionary';
  params: {
    type_map: {[columnName: string]: WBType};
  };
}

export interface MediaTable {
  columns: Array<string | number>;
  data: any[][];
  column_types?: DictionaryWBType;
}

export type MediaType =
  | 'string'
  | 'number'
  | 'unknown'
  | 'boolean'
  | 'image-file'
  | 'audio-file'
  | 'html-file'
  | 'bokeh-file'
  | 'object3D-file'
  | 'video-file';

function valToMediaType(val: any): MediaType {
  if (typeof val === 'string' || val === null) {
    return 'string';
  } else if (typeof val === 'number') {
    return 'number';
  } else if (typeof val === 'boolean') {
    return 'boolean';
  } else if (_.isArray(val)) {
    if (val.length === 0) {
      return 'unknown';
    }
    // Use the first entry to determine type
    return valToMediaType(val[0]);
  } else if (_.isObject(val)) {
    if (
      // We don't use .type, but some old demo code did and I don't
      // want to break it
      (val as any).type === 'image-file'
    ) {
      return 'image-file';
    } else if (
      [
        'image-file',
        'video-file',
        'audio-file',
        'html-file',
        'bokeh-file',
        'object3D-file',
      ].includes((val as any)._type)
    ) {
      return (val as any)._type;
    }
  }
  return 'unknown';
}

function wbTypeToMediaType(t: WBType): Types.Type {
  // TODO: Fill complete the mapping from python types to JS types here. Returning unknown
  // will result in falling back to content-inferred typing for now.
  if (t.wb_type === 'wandb.TableForeignIndex') {
    // For foreign indexes, they will always be integers. We should treat them as such.
    return 'number';
  } else if (t.wb_type === 'dictionary') {
    const propertyTypes: {[key: string]: Types.Type} = {};
    const types = (t as DictionaryWBType).params.type_map;
    Object.keys(types).forEach(pType => {
      propertyTypes[pType] = wbTypeToMediaType(types[pType]);
    });
    return {
      type: 'object',
      propertyTypes,
    };
  } else if (t.wb_type === 'number') {
    return 'number';
  }

  return 'unknown';
}

export const detectColumnTypes = (table: MediaTable): Types.Type[] => {
  const types = table.columns.map((c, i) => {
    let res;
    if (table.column_types && table.column_types.params.type_map[c]) {
      res = wbTypeToMediaType(table.column_types.params.type_map[c]);
    }
    if (!res || res === 'unknown') {
      return valToMediaType(table.data[0][i]);
    } else {
      return res;
    }
  });
  return types as MediaType[];
};

// TODO: agg types are duplicated everywhere
export const agg = (
  type: 'concat' | 'max' | 'min' | 'avg' | undefined,
  data: any[]
) => {
  if (type == null || type === 'concat') {
    return data;
  } else if (type === 'max') {
    return _.max(data);
  } else if (type === 'min') {
    return _.min(data);
  } else {
    return _.sum(data) / data.length;
  }
};
